var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      style: {
        display: _vm.hasDescription ? "" : "none",
      },
    },
    [
      _vm.hasDescription
        ? [
            _vm.opened
              ? [
                  _c("m-description", {
                    ref: "description",
                    staticClass: "show-description-modal",
                    on: { close: _vm.onClose },
                  }),
                ]
              : _vm._e(),
            _vm.type === "mini"
              ? _c(
                  "a",
                  {
                    staticClass:
                      "show-description-link show-description-link--mini",
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.showDescription },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "show-description-link-icon",
                        attrs: {
                          width: "20",
                          height: "20",
                          viewBox: "0 0 20 20",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: {
                            cx: "10",
                            cy: "10",
                            r: "9",
                            stroke: "#8E9CBB",
                            "stroke-width": "2",
                            fill: "none",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6Z",
                            fill: "#8E9CBB",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M9 14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14Z",
                            fill: "#8E9CBB",
                          },
                        }),
                      ]
                    ),
                    _c("span", { staticClass: "show-description-link-text" }, [
                      _vm._v("Показать описание"),
                    ]),
                  ]
                )
              : _c(
                  "a",
                  {
                    staticClass: "show-description-link",
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.showDescription },
                  },
                  [_vm._v("Показать описание")]
                ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }